import { isEmpty } from './verify';

function pairwiseCompare(arrayA, arrayB, identifier) {
  return arrayA.length === arrayB.length && arrayA.every((itemA, i) => identifier(itemA) === identifier(arrayB[i]));
}

export function containsSameBy(arrayA, arrayB, identifier) {
  if (arrayA === arrayB) {
    return true;
  }
  if (isEmpty(arrayA) || isEmpty(arrayB)) {
    return isEmpty(arrayA) && isEmpty(arrayB);
  }
  return pairwiseCompare(arrayA, arrayB, identifier);
}
